// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';
import { renderAllCheckbox } from '../reports/NewView';

export default class ActiveTabChanger extends JQueryView {
  syncFundinno: boolean;
  fileRoot: string;
  constructor(syncFundinno: boolean, fileRoot: string) {
    super(fileRoot);
    $('.fundinno-market-participants-check').hide();
    $('.select-all').trigger('click');
  }

  changeActiveTab(tab: string) {
    const tabs = [
      '.select-all',
      '.select-all-stockholders',
      '.select-fundinno-stockholders',
      '.select-not-fundinno-stockholders',
      '.fundinno-market-participants',
      '.select-all-rightholders',
      '.select-fundinno-rightholders',
      '.select-not-fundinno-rightholders',
    ];
    const activeTab = tabs.find(t => t === tab);
    activeTab && $(`${activeTab}`).addClass('active');
    const inactiveTabs = tabs.filter(t => t !== tab);
    inactiveTabs.map(t => $(`${t}`).removeClass('active'));
  }

  @on({ event: 'click', selector: '.select-all' })
  selectAll() {
    this.changeActiveTab('.select-all');
    $('tbody').show();
    $('.fundinno-market-participants-check').hide();
    $('.active-tab-changeable tbody tr').show();
    $('.mail').show();
    $('.stocks_amount').show();
    $('.rights_amount').show();
    $('.status').show();
    renderAllCheckbox();
  }

  @on({ event: 'click', selector: '.select-all-stockholders' })
  selectAllStockholders() {
    this.changeActiveTab('.select-all-stockholders');
    $('tbody').show();
    $('.fundinno-market-participants-check').hide();
    $('.is_stockholder').show();
    $('.active-tab-changeable tbody tr')
      .not('.is_stockholder')
      .hide();
    $('.mail').show();
    $('.stocks_amount').show();
    $('.rights_amount').show();
    $('.status').show();
    renderAllCheckbox();
  }

  @on({ event: 'click', selector: '.select-fundinno-stockholders' })
  selectFundinnoStockholders() {
    this.changeActiveTab('.select-fundinno-stockholders');
    $('tbody').show();
    $('.fundinno-market-participants-check').hide();
    $('.has_fundinno_stocks').show();
    $('.active-tab-changeable tbody tr')
      .not('.has_fundinno_stocks')
      .hide();
    $('.mail').show();
    $('.stocks_amount').show();
    $('.rights_amount').show();
    $('.status').show();
    renderAllCheckbox();
  }

  @on({ event: 'click', selector: '.select-not-fundinno-stockholders' })
  selectNotFundinnoStakeholders() {
    this.changeActiveTab('.select-not-fundinno-stockholders');
    $('tbody').show();
    $('.fundinno-market-participants-check').hide();
    $('.active-tab-changeable tbody tr').show();
    $('.is_rightholder').hide();
    $('.has_fundinno_rights').hide();
    $('.has_fundinno_stocks').hide();
    $('.mail').show();
    $('.stocks_amount').show();
    $('.rights_amount').show();
    $('.status').show();
    renderAllCheckbox();
  }

  @on({ event: 'click', selector: '.fundinno-market-participants' })
  selectFundinnoMarketParticipants() {
    this.changeActiveTab('.fundinno-market-participants');
    $('.fundinno-market-participants').addClass('active');
    $('tbody').hide();
    $('.fundinno-market-participants-check').show();
    $('.mail').hide();
    $('.stocks_amount').hide();
    $('.rights_amount').hide();
    $('.status').hide();
    renderAllCheckbox();
  }

  @on({ event: 'click', selector: '.select-all-rightholders' })
  selectAllRightholders() {
    this.changeActiveTab('.select-all-rightholders');
    $('tbody').show();
    $('.fundinno-market-participants-check').hide();
    $('.is_rightholder').show();
    $('.active-tab-changeable tbody tr')
      .not('.is_rightholder')
      .hide();
    $('.mail').show();
    $('.stocks_amount').show();
    $('.rights_amount').show();
    $('.status').show();
    renderAllCheckbox();
  }

  @on({ event: 'click', selector: '.select-fundinno-rightholders' })
  selectFundinnoRightholders() {
    this.changeActiveTab('.select-fundinno-rightholders');
    $('tbody').show();
    $('.fundinno-market-participants-check').hide();
    $('.has_fundinno_rights').show();
    $('.active-tab-changeable tbody tr')
      .not('.has_fundinno_rights')
      .hide();
    $('.mail').show();
    $('.stocks_amount').show();
    $('.rights_amount').show();
    $('.status').show();
    renderAllCheckbox();
  }

  @on({ event: 'click', selector: '.select-not-fundinno-rightholders' })
  selectNotFundinnoRightholders() {
    this.changeActiveTab('.select-not-fundinno-rightholders');
    $('tbody').show();
    $('.fundinno-market-participants-check').hide();
    $('.active-tab-changeable tbody tr').show();
    $('.is_stockholder').hide();
    $('.has_fundinno_rights').hide();
    $('.has_fundinno_stocks').hide();
    $('.mail').show();
    $('.stocks_amount').show();
    $('.rights_amount').show();
    $('.status').show();
    renderAllCheckbox();
  }
}
